var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.footer},[_vm._v("没有更多了~")])}
var staticRenderFns = []

export { render, staticRenderFns }